module.exports = __webpack_public_path__ + "static/media/fees.ec441982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fees.svg
// module id = 269
// module chunks = 0